function PrivacyPolicyContent() {
  return (
    <div className="space-y-2 sm:space-y-3 text-xs sm:text-sm text-muted-foreground">
      <p>
        <strong>Titolare del trattamento:</strong> Casa di Riposo
      </p>
      <p>
        <strong>Finalità del trattamento:</strong> I tuoi dati personali
        vengono trattati per:
      </p>
      <ul className="list-disc pl-4 sm:pl-5 space-y-1">
        <li>Gestione dell'accesso al portale famiglia</li>
        <li>Condivisione documenti relativi all'ospite</li>
        <li>Comunicazioni relative ai servizi della struttura</li>
      </ul>
      <p>
        <strong>Base giuridica:</strong> Contratto di servizio e consenso
        dell'interessato.
      </p>
      <p>
        <strong>Conservazione:</strong> I dati vengono conservati per la
        durata del rapporto e successivamente per gli obblighi di legge.
      </p>
      <p>
        <strong>Diritti:</strong> Hai diritto di accedere, rettificare,
        cancellare i tuoi dati e di opporti al trattamento. Puoi esercitare
        questi diritti dalla sezione Impostazioni del portale.
      </p>
      <p>
        <strong>Contatti:</strong> Per qualsiasi richiesta relativa ai tuoi
        dati personali, contatta l'amministrazione della struttura.
      </p>
    </div>
  );
}

export default PrivacyPolicyContent;
